import { cloneDeep, cloneDeepWith } from "lodash";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from "../../../../../common_components/mdae-framework";
import { GET_REQUESTER_LIST } from "../services/get-requester-list";
import { GET_SOURCE_LIST } from "../../sources/services/get-source-list";
import { GET_REQUESTER_REFERENCE_DATA } from "../../requester/services/get-requester-reference-data";
import { GET_REQUESTER_LINKED_DATA } from "../services/get-requester-linked-data";
import { GET_REVIEW_CONTRACTORS } from "../services/get-review-contractors";
import { SAVE_AFFECTED_AUDITS } from "../services/save-affected-audits";

export const TOGGLE_REQUESTER_LIST_ACTION_POPOVER = "TOGGLE_REQUESTER_LIST_ACTION_POPOVER";
export const TOGGLE_ADD_REQUESTER_POPUP = "TOGGLE_ADD_REQUESTER_POPUP";
export const SET_REQUESTER_FORM_DATA = "SET_REQUESTER_FORM_DATA";
export const RESET_REQUESTER_POPUP_VALIDATION = "RESET_REQUESTER_POPUP_VALIDATION";
export const TOGGLE_REQUESTER_ERROR_POPUP = "TOGGLE_REQUESTER_ERROR_POPUP";
export const SET_IS_REVIEW_CONTRACTOR_VALID = "SET_IS_REVIEW_CONTRACTOR_VALID";
export const SET_EXTRA_REVIEWER_DATA = "SET_EXTRA_REVIEWER_DATA";
export const IS_EDIT_POPUP_VISIBLE = "IS_EDIT_POPUP_VISIBLE";
export const SET_PREVIOUS_REVIEW_CONTRACTOR = "SET_PREVIOUS_REVIEW_CONTRACTOR";
export const defaultRequesterFormData = {
  eaRequesterId: 0,
  contactName: '',
  contactPhoneNumber: '',
  organizationName: '',
  eaSourceId: null,
  organizationType: '',
  mainPhoneNumber: '',
  contactEmail: '',
  mainEmail: '',
  mainWebsite: '',
  notes: '',
  claimTypeCd: '',
  recordSubmissionMethod: '',
  recordSubmissionValue: '',
  effectiveDate: new Date(),
  termDate: null,
  updateDate: new Date(),
  updatedBy: '',
}
const initialRequesterLinkedData = {
  attachedProcessTemplate: [],
}
const initialState = {
  requesterList: [],
  sourcesList: [],
  requesterFormData: defaultRequesterFormData,
  recordSubmissionMethodEnums: {},
  recordSubmissionMethodList: [],
  claimTypeList: [],
  organizationTypeList: [],
  requesterLinkedData: initialRequesterLinkedData,
  isReviewContractorValid: true,
  isRequesterPageLoaded:false,
  previousReviewContractor:''
}

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_REQUESTER_LIST_ACTION_POPOVER:
    case TOGGLE_REQUESTER_ERROR_POPUP:
    case RESET_REQUESTER_POPUP_VALIDATION:
    case TOGGLE_ADD_REQUESTER_POPUP: 
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_REQUESTER_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const requesterFormData = newState.requesterFormData
          ? newState.requesterFormData
          : {};
        for (let prop in action.data.requesterFormData) {
          requesterFormData[prop] = action.data.requesterFormData[prop];
        }
        newState = { ...newState, requesterFormData: requesterFormData };
      }
      return newState;
    case SET_IS_REVIEW_CONTRACTOR_VALID:
      return { ...state,isReviewContractorValid:action.data}
    case SET_EXTRA_REVIEWER_DATA:
      return {...state,reviewContractors:action.data}
    case SET_PREVIOUS_REVIEW_CONTRACTOR:
      return {...state,previousReviewContractor:action.data.previousReviewContractor}
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_REQUESTER_LIST)(action)) {
        return { ...state, requesterList: [] };
      }
      if (isAsyncComplete(GET_REQUESTER_LIST)(action)) {
        const response = action.response;
        return { ...state, requesterList: response.requesterList };
      }
      if (isAsyncOperation(GET_SOURCE_LIST)(action)) {
        return { ...state, sourcesList: [] };
      }
      if (isAsyncComplete(GET_SOURCE_LIST)(action)) {
        const response = action.response;
        return { ...state, sourcesList: response.sourcesList };
      }
      if (isAsyncOperation(GET_REQUESTER_REFERENCE_DATA)(action)) {
        return {
          ...state,
          recordSubmissionMethodList: [],
          recordSubmissionMethodEnums: {},
          claimTypeList: [],
          organizationTypeList: []
        };
      }
      if (isAsyncComplete(GET_REQUESTER_REFERENCE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          recordSubmissionMethodList: response.recordSubmissionMethodList,
          recordSubmissionMethodEnums: response.recordSubmissionMethodEnums[0],
          claimTypeList: response.claimTypeList,
          organizationTypeList: response.organizationTypeList
        };
      }
      if (isAsyncOperation(GET_REQUESTER_LINKED_DATA)(action)) {
        return {
          ...state,
          requesterLinkedData: initialRequesterLinkedData
        };
      }
      if (isAsyncComplete(GET_REQUESTER_LINKED_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          requesterLinkedData: response
        };
      }
      if (isAsyncOperation(GET_REVIEW_CONTRACTORS)(action)) {
        return { ...state, reviewContractors: [] };
      }
      if (isAsyncComplete(GET_REVIEW_CONTRACTORS)(action)) {
        var response = action.response;
        var activeReviewContractor = response.filter(x=>x.activeInd == true);
        return { ...state, reviewContractors: activeReviewContractor,allReviewContractors:response,isRequesterPageLoaded:true };
      }
      if (isAsyncOperation(SAVE_AFFECTED_AUDITS)(action)) {
        return { ...state};
      }
      if (isAsyncComplete(SAVE_AFFECTED_AUDITS)(action)) {
        var response = action.response;
        return { ...state};
      }
      return state;
    default:
      return state;
  }
}